<template>
    <div class="w-1/3 px-2 group">
        <div class="w-full h-32 mt-3 relative overflow-hidden bg-gray-100 rounded border border-gray-200">
            <a :href="image.link" data-fancybox="gallery" class="block w-full h-full">
                <img class="w-full h-full flex-shrink-0 object-contain mx-auto"
                    :src="image.link"
                    alt=""/>
                <div class="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center pointer-events-none">
                    <EyeIcon class="h-8 w-8 text-white opacity-80" />
                </div>
            </a>
        </div>
        <div class="flex justify-between items-center text-sm text-gray-500 mt-1">
            <div v-if="image.isDefault" class="inline-flex items-center text-xs font-semibold uppercase"><CheckCircleIcon class="h-5 w-5 text-green-400 mr-1" /> {{ $t("options.previewImage") }} </div>
            <div v-if="!image.isDefault">
                <card-button
                    @click="$emit('setDefault', image)"
                    class="hover:text-green-400 pl-0">
                    <span>{{ $t("options.asPreviewImage") }}</span>
                </card-button>
            </div>
            <div class="flex items-center">
                <button type="button">
                    <TrashIcon
                        @click="$emit('deleteImage', image)"
                        class="h-4 ml-4 w-4 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { CheckCircleIcon, TrashIcon, EyeIcon } from "@heroicons/vue/outline";
import CardButton from "@/Jetstream/CardButton";

export default {
    props: ["image"],
    emits: ["deleteImage", "setDefault"],
    components: { TrashIcon, CheckCircleIcon, CardButton, EyeIcon }
};
</script>

<style scoped></style>
